import { ActionsTable } from './components/ActionsTable'
import { ActionsTableProvider } from './ActionsTableContext'

const Actions: React.VFC = () => (
  <ActionsTableProvider>
    <ActionsTable />
  </ActionsTableProvider>
)

export default Actions
